import { Can, CanView } from 'components/Can'
import { useLoggedIn } from 'hooks/useLoggedIn'
import { UserRole, Workspace } from 'types'
import { NavMenu } from './components/NavMenu/NavMenu'
import { Favorites } from './components/Favorites/Favorites'
import { AllFiles } from './components/AllFiles/AllFiles'
import { BetaTag } from 'blaze-components/BetaTag/BetaTag'
import { SubjectType } from 'utils/caslAbility'
import Styles from './WorkspaceDashboardSidebarContent.module.scss'
import { BlazeNewButton } from 'blaze-components/WorkspaceDashboardSidebar/components/NavMenu/Buttons/BlazeNewButton'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import Plus from 'blaze-ui/icons/20/Plus'
import { Button } from 'blaze-ui/Button'
import { Shimmerer } from 'blaze-ui/Shimmerer'
import { useModals } from 'almanac-ui/Modal'
import { usePaywallGuard } from 'hooks/usePaywallGuard'
import { AddMoreContentModal } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/AddMoreContentModal/AddMoreContentModal'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Planning } from './components/Planning/Planning'

export interface OrganizationalSidebarContentProps {
  workspace: Workspace
  footer: React.ReactNode
}
export const WorkspaceDashboardSidebarContent = ({ workspace, footer }: OrganizationalSidebarContentProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const isLoggedIn = useLoggedIn()
  const { isMobile } = useResponsiveDesign()
  const isVirtualMarketer = useIsVirtualMarketer()
  const { openModal } = useModals()

  const guardedOpenAddMoreContentModal = usePaywallGuard(
    () => {
      openModal(AddMoreContentModal, { allowWizardsModal: true })
    },
    { allowFreemium: true },
  )

  return (
    <>
      <Can I={'create'} a={SubjectType.ALMANAC_FILE} inWorkspace={workspace.id}>
        {!isSystemRedesignEnabled && (
          <div className={cx(Styles.blazeNewButton, 'home-tour-2')}>
            {isVirtualMarketer && !isMobile ? (
              <Shimmerer overrideChildBackgroundOnHover>
                <Button
                  variant="secondary"
                  size="md"
                  fullWidth
                  frontIcon={Plus}
                  onPress={guardedOpenAddMoreContentModal}
                >
                  Create New
                </Button>
              </Shimmerer>
            ) : (
              <BlazeNewButton variant="secondary" />
            )}
          </div>
        )}
      </Can>
      <div className={Styles.nav}>
        <NavMenu />
        {isLoggedIn && (
          <>
            {isVirtualMarketer && (
              <CanView as={[UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN]} inWorkspace={workspace.id}>
                <Planning />
              </CanView>
            )}
            {workspace?.is_virtual_marketer && isMobile ? null : (
              <CanView
                as={[UserRole.GUEST, UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN]}
                inWorkspace={workspace.id}
              >
                <Favorites />
              </CanView>
            )}

            <CanView
              as={[UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.GUEST]}
              inWorkspace={workspace.id}
            >
              <AllFiles />
            </CanView>

            <CanView as={[UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN]} inWorkspace={workspace.id}>
              <BetaTag notInCore />
            </CanView>

            {isMobile && footer}
          </>
        )}
      </div>
    </>
  )
}
